var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	59131: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	95567: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_animations_mjs-_d6a80").then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	40297: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	10705: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_mjs-_bff60").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	13435: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [4,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	29517: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	37343: () => (loadStrictSingletonVersion("default", "rxjs", false, [4,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	52241: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	69969: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_layout_mjs-_77ce1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))))),
	84529: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_platform_mjs-_90950").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	181: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	12389: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	61169: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	71252: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	53537: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a591").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	63721: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	92078: () => (loadStrictSingletonVersion("default", "leaflet", false, [4,1,9,4], () => (__webpack_require__.e("node_modules_leaflet_dist_leaflet-src_js").then(() => (() => (__webpack_require__(/*! leaflet */ 67381))))))),
	54032: () => (loadStrictSingletonVersion("default", "@fullcalendar/core", false, [4,6,1,15], () => (__webpack_require__.e("node_modules_fullcalendar_core_index_js-_95321").then(() => (() => (__webpack_require__(/*! @fullcalendar/core */ 46633))))))),
	12592: () => (loadStrictSingletonVersion("default", "@fullcalendar/core/preact.js", false, [4,6,1,15], () => (__webpack_require__.e("node_modules_fullcalendar_core_preact_js").then(() => (() => (__webpack_require__(/*! @fullcalendar/core/preact.js */ 33674))))))),
	93792: () => (loadStrictSingletonVersion("default", "@fullcalendar/core/internal.js", false, [4,6,1,15], () => (__webpack_require__.e("node_modules_fullcalendar_core_internal_js").then(() => (() => (__webpack_require__(/*! @fullcalendar/core/internal.js */ 12460))))))),
	48260: () => (loadStrictSingletonVersion("default", "@fullcalendar/core/index.js", false, [4,6,1,15], () => (__webpack_require__.e("node_modules_fullcalendar_core_index_js-_95320").then(() => (() => (__webpack_require__(/*! @fullcalendar/core/index.js */ 46633))))))),
	46136: () => (loadStrictSingletonVersion("default", "@fullcalendar/daygrid/internal.js", false, [4,6,1,15], () => (__webpack_require__.e("node_modules_fullcalendar_daygrid_internal_js-_96b81").then(() => (() => (__webpack_require__(/*! @fullcalendar/daygrid/internal.js */ 78107))))))),
	32483: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	56711: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,17,3,12], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	30029: () => (loadStrictSingletonVersion("default", "@popperjs/core", false, [4,2,11,8], () => (__webpack_require__.e("node_modules_popperjs_core_lib_index_js").then(() => (() => (__webpack_require__(/*! @popperjs/core */ 41280))))))),
	27145: () => (loadStrictSingletonVersion("default", "@angular/cdk/stepper", false, [4,17,3,10], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_stepper_mjs-_3f481").then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))))),
	56777: () => (loadStrictSingletonVersion("default", "apexcharts", false, [4,3,51,0], () => (__webpack_require__.e("node_modules_apexcharts_dist_apexcharts_common_js").then(() => (() => (__webpack_require__(/*! apexcharts */ 31633))))))),
	78571: () => (loadStrictSingletonVersion("default", "chart.js", false, [4,4,4,3], () => (__webpack_require__.e("node_modules_chart_js_dist_chart_js").then(() => (() => (__webpack_require__(/*! chart.js */ 36792))))))),
	25243: () => (loadStrictSingletonVersion("default", "rxjs", false, [4,7,8,0], () => (__webpack_require__.e("node_modules_ngx-slider-v2_node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 47707))))))),
	2287: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [4,7,8,0], () => (__webpack_require__.e("node_modules_ngx-slider-v2_node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 11313))))))),
	59132: () => (loadStrictSingletonVersion("default", "echarts", false, [4,5,5,1], () => (__webpack_require__.e("node_modules_echarts_index_js").then(() => (() => (__webpack_require__(/*! echarts */ 8408)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a590": [
		59131,
		95567
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		40297,
		59131
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		10705,
		13435,
		29517,
		37343,
		40297,
		52241,
		59131,
		69969,
		84529
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d90": [
		40297,
		59131
	],
	"node_modules_angular_cdk_fesm2022_coercion_mjs-_bff61": [
		59131
	],
	"node_modules_angular_cdk_fesm2022_layout_mjs-_77ce0": [
		10705,
		13435,
		37343,
		59131,
		84529
	],
	"node_modules_angular_cdk_fesm2022_observers_mjs-_b1b10": [
		10705,
		13435,
		37343,
		59131
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90951": [
		40297,
		59131
	],
	"node_modules_angular_cdk_fesm2022_stepper_mjs-_3f480": [
		181,
		12389,
		13435,
		29517,
		37343,
		59131,
		84529
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		13435,
		37343,
		40297,
		59131
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		59131
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		13435,
		37343,
		59131
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		61169,
		37343,
		13435
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		13435,
		37343,
		40297,
		59131
	],
	"node_modules_angular_google-maps_fesm2022_google-maps_mjs-_9ff41": [
		59131,
		40297,
		37343,
		13435
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		59131,
		71252,
		53537,
		40297
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		40297,
		59131,
		63721
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		59131,
		37343,
		40297,
		13435,
		71252
	],
	"node_modules_asymmetrik_ngx-leaflet_fesm2022_asymmetrik-ngx-leaflet_mjs-_1c881": [
		59131,
		92078
	],
	"node_modules_fullcalendar_angular_fesm2020_fullcalendar-angular_mjs-_f8e61": [
		59131,
		54032,
		40297
	],
	"node_modules_fullcalendar_daygrid_internal_js-_96b80": [
		12592,
		93792
	],
	"node_modules_fullcalendar_daygrid_index_js": [
		48260,
		93792,
		12592
	],
	"node_modules_fullcalendar_interaction_index_js": [
		48260,
		93792
	],
	"node_modules_fullcalendar_list_index_js": [
		48260,
		93792,
		12592
	],
	"node_modules_fullcalendar_timegrid_index_js": [
		48260,
		93792,
		12592,
		46136
	],
	"node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs-_2a7b1": [
		59131,
		32483,
		37343,
		13435,
		40297,
		56711,
		30029
	],
	"node_modules_ng-select_ng-select_fesm2022_ng-select-ng-select_mjs-_0c8c1": [
		59131,
		56711,
		13435,
		37343,
		40297
	],
	"node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63781": [
		59131,
		37343,
		13435
	],
	"node_modules_angular-ng-stepper_fesm2020_angular-ng-stepper_mjs-_94131": [
		59131,
		27145,
		95567,
		40297
	],
	"node_modules_ng-apexcharts_fesm2020_ng-apexcharts_mjs-_49f71": [
		59131,
		37343,
		56777
	],
	"node_modules_ng-click-outside_lib_esmodule_index_js-_993b1": [
		59131,
		40297
	],
	"node_modules_ng2-charts_fesm2022_ng2-charts_mjs-_87ca1": [
		59131,
		78571,
		37343,
		13435
	],
	"node_modules_ngx-color-picker_fesm2022_ngx-color-picker_mjs-_e33d1": [
		59131,
		40297
	],
	"node_modules_ngx-cookie-service_fesm2022_ngx-cookie-service_mjs-_86231": [
		59131,
		40297
	],
	"node_modules_ngx-drag-drop_fesm2022_ngx-drag-drop_mjs-_71521": [
		59131
	],
	"node_modules_ngx-dropzone-wrapper_fesm2022_ngx-dropzone-wrapper_mjs-_ce7a1": [
		59131,
		40297
	],
	"node_modules_ngx-echarts_fesm2022_ngx-echarts_mjs-_b7021": [
		59131,
		37343,
		13435
	],
	"node_modules_ngx-mask_fesm2022_ngx-mask_mjs-_a6a61": [
		59131,
		40297,
		56711
	],
	"node_modules_ngx-pipes_fesm2020_ngx-pipes_mjs-_bce81": [
		59131
	],
	"node_modules_ngx-slider-v2_fesm2022_ngx-slider-v2_mjs-_3ff81": [
		59131,
		40297,
		56711,
		25243,
		2287
	],
	"node_modules_ngx-spinner_fesm2022_ngx-spinner_mjs-_df271": [
		59131,
		37343,
		13435,
		95567,
		71252,
		40297
	],
	"node_modules_ngx-ui-switch_fesm2022_ngx-ui-switch_mjs-_a0e11": [
		59131,
		56711,
		40297
	],
	"node_modules_simplebar-angular_fesm2022_simplebar-angular_mjs-_85671": [
		59131
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a80": [
		40297
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90950": [
		40297
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		10705,
		40297,
		52241,
		69969
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91": [
		40297
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		63721
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a591": [
		95567
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		13435,
		37343
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		13435,
		37343
	],
	"node_modules_angular_cdk_fesm2022_stepper_mjs-_3f481": [
		181,
		12389,
		13435,
		29517,
		37343,
		84529
	],
	"webpack_sharing_consume_default_echarts_echarts": [
		59132
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}